import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import { useUiStore } from '@/stores/ui';

/** The `?` cheatsheet — spec §8.5. Every shortcut listed here is implemented. */
const GROUPS: { title: string; items: [string, string][] }[] = [
  {
    title: 'Global',
    items: [
      ['⌘K', 'Command palette'],
      ['⌘N', 'Quick add'],
      ['G then D', 'My Day'],
      ['G then I', 'Inbox'],
      ['G then P', 'Projects'],
      ['G then T', 'My Tasks'],
      ['G then N', 'Notes'],
      ['G then W', 'Workload'],
      ['⌘/', 'Toggle sidebar'],
      ['⌘⇧D', 'Toggle theme'],
      ['?', 'This sheet'],
    ],
  },
  {
    title: 'List and board (with a row focused)',
    items: [
      ['↑ ↓', 'Move focus'],
      ['Enter', 'Open'],
      ['Space', 'Select · lift a card when dragging'],
      ['E', 'Edit title'],
      ['A', 'Assign'],
      ['S', 'Status'],
      ['P', 'Priority'],
      ['D', 'Due date'],
      ['L', 'Label'],
      ['T', 'Start or stop the timer'],
      ['C', 'Comment'],
      ['X', 'Archive'],
      ['⌫', 'Delete (with confirmation)'],
    ],
  },
  {
    title: 'Task detail',
    items: [
      ['⌘Enter', 'Save'],
      ['Esc', 'Close'],
      ['M', 'Toggle watch'],
      ['⌘⇧C', 'Copy task key and link'],
    ],
  },
  {
    title: 'Note editor',
    items: [
      ['⌘S', 'Save (autosaves after 3s idle)'],
      ['⌘⇧T', 'Convert selection to a task'],
    ],
  },
];

export function ShortcutSheet() {
  const open = useUiStore((s) => s.shortcutSheetOpen);
  const setOpen = useUiStore((s) => s.setShortcutSheetOpen);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="w-[min(720px,calc(100vw-24px))]">
        <DialogTitle className="mb-3 text-[16px] font-semibold">Keyboard shortcuts</DialogTitle>
        <div className="grid max-h-[70vh] grid-cols-1 gap-4 overflow-y-auto sm:grid-cols-2">
          {GROUPS.map((group) => (
            <section key={group.title}>
              <h3 className="mb-1.5 text-[11px] font-medium uppercase tracking-wide vt-muted">
                {group.title}
              </h3>
              <dl className="flex flex-col gap-1">
                {group.items.map(([keys, description]) => (
                  <div key={keys} className="flex items-baseline gap-2 text-[12px]">
                    <dt className="vt-mono w-[74px] shrink-0 text-right vt-muted">{keys}</dt>
                    <dd className="min-w-0">{description}</dd>
                  </div>
                ))}
              </dl>
            </section>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
